import { observable } from 'mobx';

import { SerializedData, Store, RouteStore, FetchOptions, QueryCombiner, ContextStore } from 'bernie-core';
import { FlightsQueryState, FlightsShoppingPwaFlightInformationResults } from '__generated__/api/types';
import { generateInformationDeeplink } from 'utility';

export class InformationCriteriaStore extends Store {
  @observable public informationCriteria: FlightsShoppingPwaFlightInformationResults.Variables;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setCriteriaFromUrl(fetchOptions: FetchOptions) {
    const query = fetchOptions.query;
    const journeyContinuationId = query && query.journeyContinuationId;

    this.informationCriteria.flightsDetailCriteria.journeyContinuationId = journeyContinuationId;
  }

  public triggerInformation(routeStore: RouteStore, context?: ContextStore, replaceHistory?: boolean) {
    const deeplink = generateInformationDeeplink(this.informationCriteria.flightsDetailCriteria);
    const queryCombiner: QueryCombiner = (prevQuery, newQuery) => newQuery;
    routeStore.updateSearch(deeplink, undefined, replaceHistory, queryCombiner);
  }
}

InformationCriteriaStore.DEFAULTS = {
  informationCriteria: {
    queryState: FlightsQueryState.LOADING,
    flightsDetailCriteria: { journeyContinuationId: 'test' }
  }
};
